export function getIsSystemDarkModePreferred(): boolean {
    return self.matchMedia('(prefers-color-scheme: dark)').matches;
}
